export abstract class IEventDispatcher {
    abstract dispatch<T extends object>(eventName: EventName, event: T, context?: EventContext): void;
    abstract registerHandler<T extends object>(eventName: EventName, handler: EventHandler<T>): void;
    abstract unregisterHandler<T extends object>(eventName: EventName, handler: EventHandler<T>): void;
}

export enum EventName {
    ConnectionCreated = 'ConnectionCreated',
    ConnectionUpdated = 'ConnectionUpdated',
    ConnectionDeleted = 'ConnectionDeleted',
    SpeakerUpdated = 'SpeakerUpdated',
}

export interface EventContext {
    meetingId?: number;
    roomId?: number;
}

export type EventHandler<T extends object> = (event: T, context?: EventContext) => void;
